import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Navbar from "../../Components/Navbar";
import top_banner from "../../Assets/Images/provider_banner.png";
import green_circle from "../../Assets/Images/green_circle.png";
import num from "../../Assets/Images/num.png";
import CopyRight from "../../Components/CopyRight";
import Footer from "../../Components/Footer";
import ProviderForm from "./ProviderForm";

const Provider = () => {
  return (
    <Box
      sx={{
        "& .bin_2": {
          background: "transparent",
          color: "#fff",
          "& input[type=number]": {
            "-moz-appearance": "textfield",
          },
          "& input[type=number]::-webkit-outer-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "&:focus-Visible": {
            outline: "none !important",
            border: "none !important",
          },
          "&:hover": {
            border: "none",
          },
          "& .MuiInputBase-root": {
            "&::before": {
              display: "none",
            },
            "&::after": {
              display: "none",
            },
          },

          "&:focus": {
            boxShadow: "none !important",
            border: "1px solid #fff !important",
            borderRadius: "8px !important ",
          },
          "& input": {
            padding: "0px",
            // width: "100%",
            color: "#000",
            borderBottom: "1px solid",
            height: "28px",
            "&:focus": {
              outline: "none",
            },
            "&::placeholder": {
              color: "#0000008f !important",
              fontFamily: "myriadRegular",
            },
          },
        },
      
      }}
    >
      <Box position={"relative"}>
        <Typography
          component={"img"}
          src={green_circle}
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            width: { sm: "60%", xs: "90%" },
            height: "100%",
          }}
        />
        <Navbar />

        <Box
          sx={{
            position: "relative",
          }}
        >
          <Typography
            component={"img"}
            src={top_banner}
            sx={{
              width: "100%",
              height: { sm: "auto", xs: "60vh" },
              objectFit: "cover",
            }}
          />
        </Box>
        <Container>
        <Grid container spacing={1}>
            <Grid item md={1} xs={1} sx={{
                alignSelf:"center",
                height:"100%",
                position:"relative",
                "& img":{
                    background:"#e2fceb"
                }
            }}>
            <Typography component={"img"} src={num} width={"100%"}/>
            </Grid>
            <Grid item md={11} xs={11}>
          <Box
            sx={{
              py: "5rem",
              position: "relative",
            }}
          >
            <Typography
              sx={{
                fontSize: { sm: "35px", xs: "25px" },
                color: "#000",
                pb: "2rem",
              }}
            >
              CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> in Professional Settings
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "35px", xs: "25px" },
                color: "#000",
                pb: "3rem",
              }}
            >
              Services for Affiliates
            </Typography>

            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                color: "rgba(122, 123, 145, 1)",
                pb: "1.5rem",
              }}
            >
          As a professional, you are in a unique relationship with your clients. You want more than theory and correlations to help your clients identify, unlearn, and better align breathing habits to promote good CO<sub>2</sub> levels and respiration. You also want to increase the likelihood of success with the services you specialize in when breathing habits can impact client wellness and performance.
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                color: "rgba(122, 123, 145, 1)",
                pb: "3rem",
              }}
            >
              Gain access to CapnoLearning
              <sup style={{ fontSize: "8px" }}>TM</sup>  services in your practice. Service can identify problematic breathing habits and assist clients with replacing those habits with ones that promote respiration and wellness. Complete the inquiry form below, and we’ll schedule a time to discuss services we offer to support your practice setting. Together, we can help your clients discover and replace ineffective breathing habits, enhancing respiration, lasting wellness, and practice goals.
            </Typography>
            <ProviderForm />
          </Box>
          </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
      <CopyRight />
    </Box>
  );
};

export default Provider;
